import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrl: './timeline.component.scss',
})
export class TimelineComponent {
  collapsed: boolean = false;
  isSidebarCollapsed: boolean = false;

  @Input() estado: string | undefined = '';

  etapas = [
    { key: 'ASUNTO', label: 'Solicitud y asunto' },
    { key: 'DEMANDANTE', label: 'Datos del demandante' },
    { key: 'APODERADO', label: 'Datos del apoderado' },
    { key: 'DEMANDADO', label: 'Datos del demandado' },
    { key: 'DOCUMENTACION', label: 'Documentación' },
  ];

  constructor() {}

  toggleSidebar() {
    if (this.isSidebarCollapsed) {
      this.isSidebarCollapsed = !this.isSidebarCollapsed;
      setTimeout(() => {
        this.collapsed = this.isSidebarCollapsed;
      }, 500);
    } else {
      this.collapsed = !this.collapsed;
      setTimeout(() => {
        this.isSidebarCollapsed = this.collapsed;
      }, 500);
    }
  }
}
